export enum EmployeeInformation {
  Email = 'Email',
  Phone = 'Phone',
}
